export default {"src":"/_next/static/media/FINANCIALS_IMPACT_ACTIVE_ICON.7de4713b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};